export enum OrderStateFilter {
  PENDING,
  SI_REQUIRED,
  IN_MODIFICATION,
  ACCEPTANCE_NEEDED,
  ACTIVE,
  CANCELLED,
  PENDING_CANCELLATION,
  CANCEL_ACCEPTANCE_NEEDED,
  MODIFY_ACCEPTANCE_NEEDED,
  FILLED,
  EXPIRED,
  REJECTED,
  TRIGGERED,
  CREDIT_CHECKING,
  GAMMA_MID_PENDING,
  MIGRATION_ACCEPTANCE_NEEDED,
  SUSPENDED,
  EXPIRY_ACCEPTANCE_NEEDED,
  SAVED,
  PRICING,
  FILL_ERROR,
  FILL_EXPIRED,
  MATCHED,
  EXT_ACCEPTANCE_NEEDED,
  EXT_MODIFY_ACCEPTANCE_NEEDED,
  EXT_CANCEL_ACCEPTANCE_NEEDED,
  FILL_PENDING,
  FILLING,
  PENDING_FWDS,
  EXPIRY_PENDING_FWDS,
  CANCEL_PENDING_FWDS,
  PRICED,
}

export namespace OrderStateFilter {
  let elements = [
    OrderStateFilter.PENDING,
    OrderStateFilter.SI_REQUIRED,
    OrderStateFilter.IN_MODIFICATION,
    OrderStateFilter.ACCEPTANCE_NEEDED,
    OrderStateFilter.ACTIVE,
    OrderStateFilter.CANCELLED,
    OrderStateFilter.PENDING_CANCELLATION,
    OrderStateFilter.CANCEL_ACCEPTANCE_NEEDED,
    OrderStateFilter.MODIFY_ACCEPTANCE_NEEDED,
    OrderStateFilter.FILLED,
    OrderStateFilter.EXPIRED,
    OrderStateFilter.REJECTED,
    OrderStateFilter.TRIGGERED,
    OrderStateFilter.CREDIT_CHECKING,
    OrderStateFilter.GAMMA_MID_PENDING,
    OrderStateFilter.MIGRATION_ACCEPTANCE_NEEDED,
    OrderStateFilter.SUSPENDED,
    OrderStateFilter.EXPIRY_ACCEPTANCE_NEEDED,
    OrderStateFilter.SAVED,
    OrderStateFilter.PRICING,
    OrderStateFilter.FILL_ERROR,
    OrderStateFilter.FILL_EXPIRED,
    OrderStateFilter.MATCHED,
    OrderStateFilter.EXT_ACCEPTANCE_NEEDED,
    OrderStateFilter.EXT_MODIFY_ACCEPTANCE_NEEDED,
    OrderStateFilter.EXT_CANCEL_ACCEPTANCE_NEEDED,
    OrderStateFilter.FILL_PENDING,
    OrderStateFilter.FILLING,
    OrderStateFilter.PENDING_FWDS,
    OrderStateFilter.EXPIRY_PENDING_FWDS,
    OrderStateFilter.CANCEL_PENDING_FWDS,
    OrderStateFilter.PRICED,
  ];
  let alias = "com.bcdfx.model.OrderStateFilter";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
